export { CajaRutaDTOList } from "./list";



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/list/cajas/index.tsx